import { createTracker } from 'usage-tracker';
import events from '../events.yaml';
export const UniversalAuthTracker = createTracker({
  events
});
export const UniversalAuthBeamTracker = UniversalAuthTracker.clone({});